import { Chip, styled, useTheme } from "@mui/material";

import { ModuleStatus } from "Infrastructure/Api/Api";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { isPropValid } from "Infrastructure/Utils/StyleUtils";

interface ModuleStatusChipProps {
  status: ModuleStatus;
}

const StyledChip = styled(Chip, { shouldForwardProp: isPropValid })<{
  $backgroundColor: string;
  $textColor: string;
}>`
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  font-size: 12px;
  font-weight: 400;

  .MuiChip-label {
    padding: ${(props) => props.theme.spacing(0, Spacing.M)};
  }
`;

export const ModuleStatusChip = ({
  status,
}: ModuleStatusChipProps): React.ReactNode => {
  const { t } = useResource();
  const theme = useTheme();

  const isActive = status === ModuleStatus.Active;

  return (
    <StyledChip
      label={
        isActive
          ? t(Resources.Modules.AvailabilityActive)
          : t(Resources.Modules.AvailabilityInactive)
      }
      $backgroundColor={
        isActive ? theme.palette.success.dark : theme.palette.error.dark
      }
      $textColor={theme.palette.text.primary}
    />
  );
};
